import React, { useState, useEffect, createContext } from "react";
import axios from "axios";
export const AuthContextUser = createContext();

export const AuthcontexProviderUser = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("ELTECXE")) || "ELTECXE"
  );

  const login = async (inputs) => {
    const res = await axios.post("https://clinic.salamatpayanew.ir/userLogin", inputs);
    setCurrentUser(res.data);
  };

  const logOutUser = async (inputs) => {
    await axios.post("https://clinic.salamatpayanew.ir/logOutUser",inputs);
    setCurrentUser("ELTECXE");
  };
  useEffect(() => {
    localStorage.setItem("ELTECXE", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContextUser.Provider value={{ currentUser, login, logOutUser }}>
      {children}
    </AuthContextUser.Provider>
  );
};
